import { render, staticRenderFns } from "./c_pictrue.vue?vue&type=template&id=7ac462a0&scoped=true"
import script from "./c_pictrue.vue?vue&type=script&lang=js"
export * from "./c_pictrue.vue?vue&type=script&lang=js"
import style0 from "./c_pictrue.vue?vue&type=style&index=0&id=7ac462a0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac462a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac462a0')) {
      api.createRecord('7ac462a0', component.options)
    } else {
      api.reload('7ac462a0', component.options)
    }
    module.hot.accept("./c_pictrue.vue?vue&type=template&id=7ac462a0&scoped=true", function () {
      api.rerender('7ac462a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_pictrue.vue"
export default component.exports